module.exports = __webpack_public_path__ + "static/media/tarot-card-11.1f80d0e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-11.jpg
// module id = 141
// module chunks = 0